import { IThemeManager } from '../themeManager';
import { IActiveBarHelper, IActiveBarHelperFactory } from './interfaces';
import { ActiveBarHelper } from '.';


/**
 * Factory for creating IActiveBarHelper instances.
 * 
 * @export
 * @class ActiveBarHelperFactory
 * @implements {IActiveBarHelperFactory}
 */
export class ActiveBarHelperFactory implements IActiveBarHelperFactory {

    private readonly themeManager: IThemeManager;


    /**
     * Creates an instance of ActiveBarHelperFactory.
     *
     * @param {IThemeManager} themeManager The theme manager.
     * @memberof ActiveBarHelperFactory
     */
    public constructor(themeManager: IThemeManager) {
        this.themeManager = themeManager;
    }


    /**
     * Creates an instance of IActiveBarHelper.
     * 
     * @param {HTMLElement} element 
     * @returns {IActiveBarHelper} 
     * @memberof ActiveBarHelperFactory
     */
    public create(element: HTMLElement): IActiveBarHelper {
        return new ActiveBarHelper(element, this.themeManager);
    }
}